import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import SalesReport from '../../components/reports/SalesReport'

const SalesPage = () => {
    return (
        <>

            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="SALES REPORT" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <SalesReport />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SalesPage